import { Box, Button, Text, useToast } from "@chakra-ui/react";
import { zodResolver } from "@hookform/resolvers/zod";
import Axios from "axios";
import { Controller, useForm } from "react-hook-form";
import { useMutation } from "react-query";
import ReactQuill from "react-quill";
import { z } from "zod";
import { wordsLength } from "../../../../../utils/wordsLength";
import { countWords } from "../../../../../utils/countWords";
import { api } from "../../../../../services/api";


const modules = {
  toolbar: ["bold", "italic", "underline", "link", "clean"]
};


const formats = [
  'background',
  'bold',
  'color',
  'font',
  'code',
  'italic',
  'link',
  'size',
  'strike',
  'script',
  'underline',
  'blockquote',
  'header',
  'indent',
  'list',
  'align',
  'direction',
  'code-block',
  'formula',
  'image',
  'video',
  'br',
]

const schema = z.object({
  conteudo: z.string().refine(value => wordsLength(value), {
    message: "O texto deve conter entre 500 e 1000 palavras"
  })
})

async function updateHomeText(data) {
  const response = await api.post('/site/v2/atualizacao-seo-categoria/atualiza-texto-home', data)

  return response.data

}


export function TextoHome() {
  const { control, handleSubmit, watch, formState: { errors } } = useForm({
    resolver: zodResolver(schema)
  })

  const toast = useToast({
    position: "top-right",
  })

  const conteudo = watch('conteudo')

  const wordCount = countWords(conteudo)

  const { mutateAsync, isLoading: isSubmittingLoading } = useMutation({
    mutationFn: updateHomeText,
    onError: (error, variables, context) => {
      console.log('onError')
      toast({
        title: "Erro ao atualizar texto da categoria",
        status: "error",
        duration: 2000,
        isClosable: true
      })
    },
    onSuccess: (data, variables, context) => {
      console.log('onSuccess')
      toast({
        title: "Texto da home atualizado com sucesso",
        status: "success",
        duration: 2000,
        isClosable: true
      })
    }
  })

  async function handleUpdateHomeText(data) {
    try {
      await mutateAsync(data)
    } catch (error) {
      console.error('handleUpdateHomeText', error)
    }
  }

  return (
    <Box
      as="form"
      w="100%"
      onSubmit={handleSubmit(handleUpdateHomeText)}
      display="flex"
      flexDirection="column"
      alignItems="start"
      justifyContent="center"
      gap={4}
    >
        <Text 
          fontSize="sm"
          color="gray.500"
        >
          Você está alterando o texto da Home do site
        </Text>

        {wordCount && (
          <Text 
            fontSize="sm"
            color="gray.500"
          >
            {wordCount} palavras
          </Text>
        )}

        {errors.conteudo && (
          <Text 
            fontSize="sm"
            color="red.500"
          >
            {errors.conteudo.message}
          </Text>
        )}

        <Controller
          control={control}
          defaultValue=""
          rules={{ required: 'Campo obrigatório' }}
          name="conteudo"
          render={({ field }) => 
            <ReactQuill 
              theme="snow" 
              {...field} 
              modules={modules}
              formats={formats}
              placeholder="Digite o texto da Home do site aqui..."
              id="editor"
              style={{ height: "300px", width: "100%" }}
            />
          }
        />
        
        <Button 
          colorScheme="blue"
          type="submit"
          disabled={isSubmittingLoading}
          mt={10}
          isLoading={isSubmittingLoading}
        >
          Salvar
        </Button>

    </Box>
  )
}